import React, { useContext } from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import cocaCola from './../../images/mainPage/coca-cola-logo-svgrepo-com.svg';
import google from './googleLogo.png';
import morganStanley from './Morgan-Stanley-Logo-2001-2006.png';
import microsoft from './Microsoft_logo_(2012).svg.png';
import humana from './humanaLogo.png';
import kimberlyClark from './kimberlyClarkLogo.png';
import kpmg from './kpmgLogo.png';
import pepsico from './pepsicoLogo.png';
import skypoint from './skypointHotel.png';
import slowfood from './slowfoodLogo.png';
import experis from './experisLogo.png';
import bgsf from './bgsfLogo.png';
import intellinet from './intellinetLogo.png';
import tcs from './tcsLogo.png';
import lennar from './lennarLogo.png';
import shawfloors from './shawfloorsLogo.png';
import idc from './idcLogo.png';
import classes from './CompaniesBlock.module.css';
import { ThemeContext } from '../../App';

export default function CompaniesBlock() {
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 7,
      slidesToSlide: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 640 },
      items: 4,
      slidesToSlide: 1,
    },
    mobile: {
      breakpoint: { max: 640, min: 0 },
      items: 3,
      slidesToSlide: 1,
    },
  };

  const companies = [
    cocaCola,
    google,
    morganStanley,
    microsoft,
    humana,
    kimberlyClark,
    kpmg,
    pepsico,
    skypoint,
    slowfood,
    experis,
    bgsf,
    intellinet,
    tcs,
    lennar,
    shawfloors,
    idc,
  ];

  const { theme } = useContext(ThemeContext);

  return (
    <div id={classes[theme]} className={classes.container}>
      <h2 className="text-center text-smBtwPages md:text-mdBtwPages lg:text-lgBtwPages">
        Companies we work with
      </h2>

      <Carousel
        showDots={false}
        responsive={responsive}
        infinite={true}
        autoPlay
        autoPlaySpeed={1500}
        removeArrowOnDeviceType={['tablet', 'mobile', 'desktop']}
      >
        {companies.map((item) => (
          <div
            key={item}
            className="flex items-center h-full w-full justify-center"
          >
            <img className={classes.companyBlockInCarousel} src={item} />
          </div>
        ))}
      </Carousel>
    </div>
  );
}
